import { ArrowForward } from '@mui/icons-material'
import { Button, Grid, Stack, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { BuildingIcon, BuildingsIcon, MoneyIcon } from '../../../../components/icons'
import { StyledCard } from '../../../../components/StyledCard'

const TYPES = [
  {
    path: '/browse/smallBusiness',
    name: 'Small business',
    icon: <MoneyIcon />,
    description: 'SBIR/STTR grants for small businesses',
  },
  {
    path: '/browse/federal',
    name: 'Federal opportunities',
    icon: <BuildingsIcon />,
    description: 'All federal U.S. opportunities',
  },
  {
    path: '/browse/privateFoundations',
    name: 'Private foundations',
    icon: <BuildingIcon />,
    description: ' A list of private grant providers',
  },
]

export const SearchTypes: FC = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <Grid mt={3} container spacing={3}>
      {TYPES.map((type) => (
        <Grid key={type.name} item xs={4}>
          <StyledCard>
            <Stack mb={1.5} direction="row" alignItems="center" justifyContent="space-between">
              {type.icon}

              <Button
                variant="text"
                color="primary"
                endIcon={<ArrowForward />}
                onClick={() => navigate(type.path)}
                sx={{ px: 1.5, fontSize: '0.875rem', textTransform: 'none' }}
              >
                View
              </Button>
            </Stack>

            <Typography
              mb={1}
              color="secondary"
              fontSize="1rem"
              fontWeight={theme.typography.fontWeightBold}
            >
              {type.name}
            </Typography>

            <Typography
              fontSize="0.875rem"
              color="primary.dark"
              fontWeight={theme.typography.fontWeightBold}
            >
              {type.description}
            </Typography>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  )
}
